import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mainCoverages',
    pure: false
})
export class MainCoveragesPipe implements PipeTransform {
    transform(items: any[], mainIds?: string[]): any[] {
        if (!mainIds) {
            mainIds = ['C1', 'C2'];
        }
        return items.filter(item => mainIds.indexOf(item.id) > -1);
    }
}
